import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ParkingManagementService } from '@core/services/parking-management.service';
import { ParkingManagementActions } from './parking-managment.actions';

@Injectable()
export class ParkingManagementEffects {
  private actions$ = inject(Actions);
  private parkingManagementService = inject(ParkingManagementService);
  private translateService = inject(TranslateService);
  getParkingManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParkingManagementActions.loadParkingManagement),
      mergeMap((data) =>
        this.parkingManagementService.getParkingManagement(data).pipe(
          map((parkingManagement) =>
            parkingManagement.success
              ? ParkingManagementActions.loadParkingManagementSuccess(parkingManagement)
              : ParkingManagementActions.loadParkingManagementFailure(parkingManagement)
          ),
          catchError((error) =>
            of(
              ParkingManagementActions.loadParkingManagementFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  // addParkingManagement$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(ParkingManagementActions.addEditParkingManagement),
  //     mergeMap((data) =>
  //       this.parkingManagementService.addParkingManagement(data.ParkingManagement).pipe(
  //         map((parkingManagement) => {
  //           if (parkingManagement.success) {
  //             return ParkingManagementActions.addParkingManagementSuccess(parkingManagement);
  //           } else return ParkingManagementActions.addParkingManagementFailure(parkingManagement);
  //         }),
  //         catchError((error) =>
  //           of(
  //             ParkingManagementActions.addParkingManagementFailure({
  //               error,
  //               success: false,
  //               message: this.translateService.instant('Something went wrong'),
  //             })
  //           )
  //         )
  //       )
  //     )
  //   )
  // );

  addMarkAsPaidParkingManagement$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ParkingManagementActions.addMarkAsPaidParkingManagement),
      mergeMap((data) =>
        this.parkingManagementService.addMarkAsPaidParkingManagement(data.ParkingManagement).pipe(
          map((parkingManagement) => {
            if (parkingManagement.success) {
              return ParkingManagementActions.addMarkAsPaidSuccess(parkingManagement);
            } else return ParkingManagementActions.addMarkAsPaidFailure(parkingManagement);
          }),
          catchError((error) =>
            of(
              ParkingManagementActions.addMarkAsPaidFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
